'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var grass={1:'#21a921',2:'#0a870a'};exports.default=(0,_createColorPalette2.default)(grass,'grass');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/colors/grass.js
// module id = 536
// module chunks = 162